var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteBack2Line(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.445 2.5H17.5c.46 0 .834.373.834.833v13.334c0 .46-.373.833-.834.833H5.445a.833.833 0 0 1-.693-.371L.308 10.462a.833.833 0 0 1 0-.924L4.752 2.87a.833.833 0 0 1 .693-.371Zm.446 1.667L2.002 10l3.89 5.833h10.774V4.167H5.891Zm4.942 4.655 2.357-2.358 1.178 1.179L12.011 10l2.357 2.357-1.178 1.179-2.357-2.357-2.357 2.357-1.179-1.179L9.654 10 7.297 7.643l1.179-1.179 2.357 2.357Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBack2Line);
export default __webpack_public_path__ + "static/media/delete-back-2-line.037f253d570bcbf27fb71f99d075ec5d.svg";
export { ForwardRef as ReactComponent };